import { isFunction, isString } from './validator.js';

const events = {};
function validateOnOffParams(name, listener) {
  return !name || !listener || !isString(name) || !isFunction(listener);
}

export default {
  on(name, listener) {
    if (validateOnOffParams(name, listener)) {
      throw new Error('invalid on params');
    }
    events[name] = events[name] || [];
    events[name].push(listener);
  },
  off(name, listener) {
    if (validateOnOffParams(name, listener)) {
      throw new Error('invalid on params');
    }
    if (!events[name]) {
      return;
    }
    const listenerList = events[name];
    const index = listenerList.indexOf(listener);
    if (index > -1) {
      listenerList.splice(index, 1);
    }
  },
  fire(name, ...data) {
    if (!name || !isString(name)) {
      throw new Error('invalid fire params');
    }
    if (!events[name]) {
      return;
    }
    events[name].forEach((listener) => listener(...data));
  }
};
